import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=64130ff2&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64130ff2')) {
      api.createRecord('64130ff2', component.options)
    } else {
      api.reload('64130ff2', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=64130ff2&", function () {
      api.rerender('64130ff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/layout/Layout.vue"
export default component.exports